export default {
  pt: {
    'shipments.contratosSidebar.allSituations': 'Todas',
    'shipments.contratosSidebar.situation.planned': 'Previsto',
    'shipments.contratosSidebar.situation.awaitingRelease': 'Aguardando liberação',
    'shipments.contratosSidebar.situation.inProgress': 'Em andamento',
    'shipments.contratosSidebar.situation.halted': 'Paralisado',
    'shipments.contratosSidebar.situation.completed': 'Finalizado',
    'shipments.contratosSidebar.situation.completedPending': 'Finalizado c/ pendência',
    'shipments.contratosSidebar.search': 'Buscar em tudo: contrato, placa, motorista, viagem, lote, NF…',
    'shipments.contratosSidebar.situation': 'Situação',
    'shipments.contratosSidebar.searchSituation': 'Buscar situação…',
    'shipments.contratosSidebar.customer': 'Cliente',
    'shipments.contratosSidebar.allCustomers': 'Todos os clientes',
    'shipments.contratosSidebar.searchCustomer': 'Buscar cliente…',
    'shipments.contratosSidebar.empty': 'Nenhum contrato.',
  },
  en: {
    'shipments.contratosSidebar.allSituations': 'All',
    'shipments.contratosSidebar.situation.planned': 'Planned',
    'shipments.contratosSidebar.situation.awaitingRelease': 'Awaiting release',
    'shipments.contratosSidebar.situation.inProgress': 'In progress',
    'shipments.contratosSidebar.situation.halted': 'Halted',
    'shipments.contratosSidebar.situation.completed': 'Completed',
    'shipments.contratosSidebar.situation.completedPending': 'Completed with pending items',
    'shipments.contratosSidebar.search': 'Search everything: contract, plate, driver, trip, batch, invoice…',
    'shipments.contratosSidebar.situation': 'Situation',
    'shipments.contratosSidebar.searchSituation': 'Search situation…',
    'shipments.contratosSidebar.customer': 'Customer',
    'shipments.contratosSidebar.allCustomers': 'All customers',
    'shipments.contratosSidebar.searchCustomer': 'Search customer…',
    'shipments.contratosSidebar.empty': 'No contracts.',
  },
  es: {
    'shipments.contratosSidebar.allSituations': 'Todas',
    'shipments.contratosSidebar.situation.planned': 'Previsto',
    'shipments.contratosSidebar.situation.awaitingRelease': 'Esperando liberación',
    'shipments.contratosSidebar.situation.inProgress': 'En curso',
    'shipments.contratosSidebar.situation.halted': 'Paralizado',
    'shipments.contratosSidebar.situation.completed': 'Finalizado',
    'shipments.contratosSidebar.situation.completedPending': 'Finalizado con pendientes',
    'shipments.contratosSidebar.search': 'Buscar en todo: contrato, placa, conductor, viaje, lote, factura…',
    'shipments.contratosSidebar.situation': 'Situación',
    'shipments.contratosSidebar.searchSituation': 'Buscar situación…',
    'shipments.contratosSidebar.customer': 'Cliente',
    'shipments.contratosSidebar.allCustomers': 'Todos los clientes',
    'shipments.contratosSidebar.searchCustomer': 'Buscar cliente…',
    'shipments.contratosSidebar.empty': 'No hay contratos.',
  },
}
